/* eslint-disable react/no-unused-class-component-methods */
'use strict';

import React, { Component } from 'react'

import _ from 'lodash'

import { handleChange } from '@/Form/Functions/eventsHandling'
import getFormStatus    from '@/Form/Functions/getFormStatus'

import FormElement from '@/Form/toolkit/FormElement'

import bemit from '@function/bemit'

import { centsFromPrice, priceFromCents, mergeDeep, isTrue } from '@root/utility'

const { app, moment } = window;

export default class Shipping extends Component
{
	state =
	{
		form_data: { },
		status_messages: { },
		EC: { },
		permissions: { title: 'not_logged_in' },

		loading: true
	};

	componentDidMount ()
	{
		const component = this, props = this.props;

		app.push(
		{
			event: 'serverOrderProcessUpdate',
			cb: component.handleProcessFetched
		});

		app.push(
		{
			event: 'orderProcessErrorsUpdate',
			cb: component.handleErrorsUpdate
		});

		app.push(
		{
			event: 'sessionChange',
			cb: component.handleSessionChange
		});

		if (app.state.order_process?.fetched)
		{
			component.handleProcessFetched();
		}

		if (app.state.session.login)
		{
			component.handleSessionChange('componentWillMount');
		}
	}

	componentWillUnmount ()
	{
		const component = this, props = this.props;

		app.delete(
		{
			event: 'serverOrderProcessUpdate',
			cb: component.handleProcessFetched
		});

		app.delete(
		{
			event: 'orderProcessErrorsUpdate',
			cb: component.handleErrorsUpdate
		});

		app.delete(
		{
			event: 'sessionChange',
			cb: component.handleSessionChange
		});
	}

	handleSessionChange = (source) =>
	{
		const component = this, props = this.props;

		component.setState(
		{
			EC: _.cloneDeep(app.state.session.EC),
			permissions: _.cloneDeep(app.state.session.permissions)
		});
	}

	handleErrorsUpdate = () =>
	{
		const component = this, props = this.props;
		const errors = (app.state.order_process.errors || { }).shipping;

		let status_messages = Object.assign({ }, (errors.status_messages || { }));

		component.setState(
		{
			error: (errors || { }).error,
			status_messages: status_messages
		});
	}

	handleProcessFetched = () =>
	{
		const component = this, props = this.props, state = this.state;

		const online_shipping = app.state.cart
		.every(item => isTrue(item.cart_onlineTicket));

		const form_data = mergeDeep({ }, app.state.order_process['shipping']);

		if (online_shipping)
		{
			if (form_data['shipping[method]'] !== 'online')
			{
				form_data['shipping[method]'] = 'online';

				app.state.order_process.shipping['shipping[method]'] = 'online';

				app.emit('order_processChange', { source: 'Shipping' });
			}
		}
		else if (app.state.order_process.shipping['shipping[method]'] === 'online')
		{
			app.state.order_process.shipping['shipping[method]'] = '';

			form_data['shipping[method]'] = '';

			app.emit('order_processChange', { source: 'Shipping' });
		}

		component.setState(
		{
			form_data: form_data,

			loading: false
		});
	}

	handleChange = (e, data) =>
	{
		const component = this;

		if (data.value === 'synergies' && moment().isBefore('2022-11-02', 'day'))
		{
			return;
		}

	// client_phone did mount
		if (!e && data.name === 'shipping[client_phone]' && !data.value)
		{
			return;
		}

		handleChange.bind(component)(e, data);

		if (data.value === 'synergies' && data.name === 'shipping[method]' &&
			!component.state.form_data['shipping[client_phone]'])
		{
			const billing = app.state.order_process.billing || { };

			handleChange.bind(component)(e,
			{
				...data,

				name: 'shipping[client_phone]',
				value: billing['billing[phone]'] || ''
			});
		}

		app.state.order_process['shipping'] = mergeDeep({ },
			component.state.form_data
		);

		if (!e)
		{
			let store_value = app.state.order_process['shipping'][data.name];

			if (typeof store_value !== 'undefined' && store_value !== data.value)
			{
				return;
			}
			else if (typeof store_value === 'undefined' && data.value === '')
			{
				return;
			}
		}

		if (e)
		{
			app.emit('order_processChange', { source: 'Shipping' });
		}
	}

	render ()
	{
		const component = this, props = this.props, state = this.state;

		let shipping_methods =
		[
			{
				title: 'À domicile',
				value: 'home',
				price: '0'
			},
			{
				title: 'À mon CE',
				value: 'EC',
				price: '0'
			},
			{
				title: 'Retrait Synergies',
				value: 'synergies',
				price: '0'
			}
		];

		let shipping_config = _.cloneDeep(state.EC.config || { });

		if (Object.keys(shipping_config.override || { }).length &&
			state.permissions.title !== 'EC')
		{
			Object.keys(shipping_config).forEach(function (field)
			{
				if ([false, 'false'].includes(shipping_config.override[field]))
				{
					shipping_config[field] = shipping_config.override[field];
				}
			});
		}

		let online_shipping = app.state.cart
		.every(item => isTrue(item.cart_onlineTicket));

		if (online_shipping)
		{
			shipping_methods =
			[
				{
					title: 'e-billets : livraison électronique',
					value: 'online',
					price: '0'
				}
			];

			shipping_config =
			{
				shipping_online: true
			};
		}

		shipping_methods = shipping_methods
		.filter(method => isTrue(shipping_config['shipping_' + method.value]))
		.map(function (method, key)
		{
			let stroke_class = 'c-order-process__stroke';

			if (state.form_data['shipping[method]'] === method.value)
			{
				stroke_class += ' active';
			}

			let price;

			if (state.EC && method.title === 'À domicile')
			{
				price = state.EC.config.shipping_home_price;
			}
			else if (state.EC && method.title === 'À mon CE')
			{
				price = state.EC.config.shipping_EC_price;
			}

			if (price)
			{
				price = priceFromCents(centsFromPrice(price));
			}

			price = price || method.price;

			if ([0, '0', '0.00'].includes(price))
			{
				price = 'Offert';
			}
			else
			{
				price += ' €';
			}

			let class_name = 'c-form-element c-form-element--inline';

			if (method.value === 'synergies' && moment().isBefore('2022-11-02', 'day'))
			{
				class_name += ' c-form-element--unavailable';

				price = 'Non disponible jusqu\'au 1er novembre inclus.';
			}

			let output =
			(
				<div className="c-order-process__shipping-method" key={ key }>

					<FormElement className={ class_name }
						name="shipping[method]" type="radio" data={ state.form_data }
						label={ method.title } status={ state.status_messages }
						onChange={ component.handleChange }
						radio_value={ method.value }
					/>

					<div className={ stroke_class } />

					<span className="c-order-process__shipping-price">
						{ price }
					</span>

				</div>
			);

			return output;
		});

		let shipping_address =
		(
			<div className="c-order-process__shipping-address">

				<div className="c-order-process__separator
					u-margin-top-10 u-margin-bottom-10"
				/>

				<div className="u-negative-margin">

					<div className="o-grid-2">

						<div className="o-grid__item">
							<FormElement name="shipping[firstname]"
								className={ bemit('c-form-element', ['order']) }
								type="text" data={ state.form_data }
								label="Prénom" status={ state.status_messages }
								onChange={ component.handleChange }
							/>
						</div>

						<div className="o-grid__item">
							<FormElement name="shipping[lastname]"
								className={ bemit('c-form-element', ['order']) }
								type="text" data={ state.form_data }
								label="Nom" status={ state.status_messages }
								onChange={ component.handleChange }
							/>
						</div>

						<div className="o-grid__item">
							<FormElement name="shipping[line_1]"
								className={ bemit('c-form-element', ['order']) }
								type="text" data={ state.form_data }
								label="Adresse" status={ state.status_messages }
								onChange={ component.handleChange }
							/>
						</div>

						<div className="o-grid__item">
							<FormElement name="shipping[line_2]"
								className={ bemit('c-form-element', ['order']) }
								type="text" data={ state.form_data }
								label="Complément d'adresse" status={ state.status_messages }
								onChange={ component.handleChange }
							/>
						</div>

						<div className="o-grid__item">
							<FormElement name="shipping[zip_code]"
								className={ bemit('c-form-element', ['order']) }
								type="text" data={ state.form_data }
								label="Code postal" status={ state.status_messages }
								onChange={ component.handleChange }
							/>
						</div>

						<div className="o-grid__item">
							<FormElement name="shipping[city]"
								className={ bemit('c-form-element', ['order']) }
								type="text" data={ state.form_data }
								label="Ville" status={ state.status_messages }
								onChange={ component.handleChange }
							/>
						</div>

					</div>

				</div>

			</div>
		);

		if ([true, 'true'].indexOf(state.form_data['shipping[is_billing]']) !== -1)
		{
			shipping_address = undefined;
		}

		let default_value = 'true';

		if ([false, 'false'].indexOf(state.form_data['shipping[is_billing]']) !== -1)
		{
			default_value = 'false';
		}

		let shipping_address_cb =
		(
			<FormElement className="c-form-element u-full-width u-margin-top-15"
				name="shipping[is_billing]" type="checkbox" data={ state.form_data }
				label="Mon adresse de livraison est la même que mon adresse de facturation"
				status={ state.status_messages }
				onChange={ component.handleChange }
				defaultValue={ default_value }
			/>
		);

		if (state.form_data['shipping[method]'] !== 'home')
		{
			shipping_address_cb = undefined;
			shipping_address    = undefined;
		}

		let info_address, client_phone_number;

		if (state.form_data['shipping[method]'] === 'synergies')
		{
			info_address =
			{
				title: 'Association Synergies',
				subtitle: '13h - 18h du lundi au vendredi',
				line_1: '22 avenue Benjamin Gomez',
				line_2: 'ZI St Frédéric - BP50404',
				zip_code: '64100',
				city: 'Bayonne'
			};

			client_phone_number =
			(
				<div className="c-order-process__client-phone">

					<div className="c-order-process__client-phone-txt">
						Dès que votre commande est prête SYNERGIES vous contacte par téléphone pour réserver votre date et heure de retrait&nbsp;:
					</div>

					<FormElement className="c-form-element c-form-element--order"
						name="shipping[client_phone]" type="tel"
						data={ state.form_data }
						label="Votre numéro de téléphone"
						status={ state.status_messages }
						onChange={ component.handleChange }
					/>

				</div>
			);
		}

		if (state.form_data['shipping[method]'] === 'EC' && state.EC)
		{
			info_address = state.EC.address;

			info_address.title = state.EC.company;
		}

		if (info_address)
		{
			let line_2;

			if (info_address.line_2)
			{
				line_2 =
				(
					<div className="c-order-process__shipping-EC-address-line">
						{ info_address.line_2 }
					</div>
				);
			}

			let title;

			if (info_address.title)
			{
				title =
				(
					<div className="c-order-process__shipping-EC-address-line">
						<div><strong>{ info_address.title }</strong></div>
						{ info_address.subtitle }
					</div>
				);
			}

			info_address =
			(
				<address className="c-order-process__shipping-EC-address">

					{ title }

					<div className="c-order-process__shipping-EC-address-line">
						{ info_address.line_1 }
					</div>

					{ line_2 }

					<div className="c-order-process__shipping-EC-address-line">
						{ info_address.zip_code }
						{' '}
						{ info_address.city }
					</div>

				</address>
			);
		}

		var output =
		(
			<div className="c-order-process__step">

				<h2 className="c-order-process__title">
					<span className="c-order-process__title-number">2</span>
					Mode de livraison
				</h2>

				{ getFormStatus(state) }

				<div className="c-order-process__choices-inline"
					data-count={ String(shipping_methods.length) }>
					{ shipping_methods }
				</div>

				{ shipping_address_cb }

				{ shipping_address }

				{ client_phone_number }

				{ info_address }

			</div>
		);

		return output;
	}
}